
import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import ProjectMixin from '@/_mixins/project'
import AddButton from '@/_components/button/add/add.vue'
import { COURSE_QUERY } from '@/views/Project/course/gql/queries'
import { ApolloQueryResult } from '@apollo/client'
import { Query, Course, PageInfo } from '@/schema'

export default {
    name: 'CoursesSettingsItems',
    mixins: [ProjectMixin],
    components: {
        AddButton,
        AppToolbar,
    },
    data() {
        return {
            isFetchingCourses: true,
            courses: [] as Course[],
            pageInfo: null as Maybe<PageInfo>,
            infiniteID: Date.now(),
            isMounted: false,
        }
    },
    methods: {
        async fetchCourses($state: any) {
            this.isFetchingCourses = true
            try {
                const coursesResult: ApolloQueryResult<Query> = await this.$apollo.query({
                    query: COURSE_QUERY,
                    variables: {
                        projectId: this.currentProjectId,
                        after: this.pageInfo?.endCursor,
                    },
                    fetchPolicy: 'network-only',
                })
                coursesResult.data?.courses?.nodes?.forEach((course) => {
                    this.courses.push(course)
                })
                this.pageInfo = coursesResult.data?.courses?.pageInfo || null
                if (this.pageInfo?.hasNextPage === false) {
                    $state.complete()
                } else {
                    $state.loaded()
                }
            } catch (error) {
                $state.complete()
                throw error
            } finally {
                this.isFetchingCourses = false
            }
        },
        createCourse() {
            //
        },
    },
    mounted() {
        this.isMounted = true
    },
}
